module.exports = __webpack_public_path__ + "static/img/middleItem1.a071b45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modularMain/middleItem1.png
// module id = IcDp
// module chunks = 31